import { lazy } from "react";
import { Navigate } from "react-router";

const Configuration = lazy(() => import("./components/Configuration"));
const Log = lazy(() => import("./components/Log"));

const bookingRoutes = [
  { index: true, element: <Navigate replace to={`${process.env.PUBLIC_URL}/dashboard/booking/configuration`} /> },
  { path: "configuration", element: <Configuration /> },
  { path: "log", element: <Log /> },
];

export default bookingRoutes;
